let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9jXWv")).then(() => parcelRequire('4z9XK'));